<template>
  <!-- 课程详情页---目录部分 -->
  <div class="course-catalog">
    <div class="lesson" v-for="(item, index) in lessonList" :key="index">
      <div class="lesson-row" :class="[!item.lessonFiles || !item.lessonQuests ? 'not-child':'']">
        <!-- 课节名称 -->
        <div class="row-item wes-2 lesson-name">{{item.name}}</div>
        <!-- 课节时间-->
        <div class="row-item lesson-time" :class="[item.lessonsPattern === 0 ?'':'lesson-time-async']">
          <span>开放时间：</span>
          <span>{{dayjs(item.lessonsBeginTime*1000).format('YYYY.MM.DD HH:mm')}}</span>
        </div>
        <!--教师，助教 -->
        <div class="row-item flex-layout wes lesson-teacher"
          :class="[item.lessonsPattern === 0? '':'lesson-teacher-async']">
          <span class="wes" v-if="item.teacherName">授课教师：{{item.teacherName}}</span>
        </div>
        <!-- 按钮 -->
        <div class="row-item lesson-btn">
          <button class="btn-blue" :class="{'btn-grey':item.canView == 0}" @click="golive(item)">
            开始学习
          </button>
        </div>
      </div>
    </div>
    <!-- 无课节-->
    <Empty :show="lessonList && lessonList.length === 0" :text="'暂无课节'"></Empty>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>您无权限查看该内容，请选择其他课程查看 （点击确定将返回课程中台页面）</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="$router.push('/home/courseList')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="hasVideoDialogVisible" width="30%">
      <span>该课程下暂无视频</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hasVideoDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        lessonList: [], //课节列表
        liveLessonId: 0,
        dialogVisible: false,
        hasVideoDialogVisible:false,
      };
    },
    computed: {},
    components: {},
    methods: {
      //获取课程列表
      async getLessonList() {
        let params = {
          courseId: this.$route.params.id
        }
        let resData = await Api.Home.getCourseLesson(params)
        // console.log(resData);
        this.lessonList = resData.data;
      },
      //跳转到百家云视频、异步课视频
      golive(item) {
        if (item.canView == 2) {
          this.$store.commit('isDisplayLogin', true);
          return;
        }

        if (item.canView == 0) {
          this.dialogVisible = true;
          return;
        }

        // console.log(item);
        this.getLiveUrl(item);

      },
      async getLiveUrl(item) {
        let id = item.id;
        // 获取课节视频地址
        let resData = await Api.Home.getLessonVideoUrl(id);
        console.log(resData);
        if (resData.msg == '该课节下暂无视频' && resData.code == 500) {
          this.hasVideoDialogVisible = true;
          return;
        }
        this.$router.push({
          path: `/home/course/live/${item.id}`,
          query: {
            type: this.$route.query.type,
            courseId: this.$route.params.id,
            index: this.$route.query.index,
          }
        });
      },
    },
    created() {},
    mounted() {
      this.getLessonList();
    },
  };
</script>

<style lang="less" scoped>
  .course-catalog {
    background-color: #fff;
    padding: 21px 4px 50px 19px;

    .lesson {
      margin-bottom: 35px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background-color: rgba(249, 249, 249, 0.34);
    }

    // 课节行 start
    .lesson-row {
      background-color: #F2F1F1;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 12px 7px 17px;

      &.not-child {
        border-radius: 10px;
      }

      // 标题
      .lesson-name {
        font-weight: bold;
        font-size: 12px;
        width: 140px;
        // padding: 10px 0;
        // flex-basis: 27%;
      }

      // 时间
      .lesson-time {
        // flex-basis: 28%;
        font-size: 12px;
        flex-shrink: 0;
        font-family: Source Han Sans CN;
        color: #999999;

        .status {
          display: inline-block;
          margin-left: 12px;
          border: 1px solid #999999;
          padding: 0 7px;
          line-height: 15px;
          border-radius: 25px;

          color: #999999;
          font-size: 12px;

          text-align: center;
          vertical-align: bottom;
        }

        .living {
          margin-left: 0px;
          padding: 0;
          border: 1px solid transparent;
          padding-right: 6px;
          width: auto !important;

          color: #ff0000;
        }

        .el-icon-s-data {
          font-size: 14px;
          color: #f00;
        }


        .living-icon {
          display: inline-block;
          // background-image: url("~@/assets/images/home/vidicon.png");
          width: 14px;
          height: 10px;
          margin: 0 2px 0 11px;
        }
      }

      // 教师
      .lesson-teacher {
        // flex-basis: 25%;
        color: #666666;
        font-size: 12px;

        span:first-child {
          flex-shrink: 0;
        }

        span:nth-child(2) {
          margin-left: 15px;
        }
      }

      // 开始学习按钮
      .lesson-btn {

        // flex-basis: 14%;
        .btn-blue {
          border-radius: 25px;
          line-height: 24px;

          color: #fff;
          font-size: 12px;
          font-weight: 500;
          padding: 0 17px;

          background-color: #508EF9;
          cursor: pointer;
        }

        .btn-grey {
          background: #c0c0c0;
        }
      }
    }

    // 课节行 end


    // 文件列表start
    .files {
      padding: 0 26px 0 19px;
      overflow: hidden;

      .file,
      .work {
        margin: 17px 0;
        font-size: 12px;
        color: #666666;

        &:hover {
          color: #508EF9;
        }
      }

      .work {
        .work-title {
          width: 240px;
        }

        .work-status {
          border: 1px solid #999999;
          padding: 0 8px;
          border-radius: 25px;
          color: #999999;
          margin-left: 15px;
          font-size: 12px;
        }

        .work-go {
          border: 1px solid #508EF9;
          padding: 0 10px;
          border-radius: 25px;
          color: #508EF9;
          line-height: 19px;
          font-size: 12px;

          &:hover {
            background-color: #508EF9;
            color: #fff;
          }
        }
      }

    }

    // 文件列表end

    /*媒体查询*/
    @media screen and (min-width:1250px) {
      padding: 26px 5px 50px 23px;

      .lesson-row {
        padding: 12px 15px 9px 21px;

        .lesson-name {
          font-size: 14px;
          width: 160px;
        }

        .lesson-time {
          font-size: 13px;
        }

        .lesson-teacher {
          font-size: 13px;
        }

        .lesson-btn {
          .btn-blue {
            line-height: 29px;

            font-size: 13px;
            padding: 0 20px;

          }
        }
      }

      .files {
        padding: 0 31px 0 23px;
        overflow: hidden;

        .file {
          font-size: 13px;
        }

        .work {
          .work-title {
            width: 300px;
          }

          .work-status {
            padding: 0 10px;
            margin-left: 18px;
            font-size: 12px;
          }

          .work-go {
            padding: 0 12px;
            line-height: 21px;
            font-size: 13px;
          }
        }
      }


    }

  }
</style>